import { IPrizeClassDescriptor } from '@/components/game/implementations/_default/_domain/models/prize-element';
import { Bingo90CallsData, Bingo90CatchUpData, Bingo90NextGameData, Bingo90ResetData } from '@/components/game/implementations/uk/bingo-90/_domain/models';
import { Bingo80CallsData, Bingo80CatchUpData, Bingo80NextGameData, Bingo80ResetData } from '@/components/game/implementations/uk/bingo-80/_domain/models';
import { Bingo75CallsData, Bingo75CatchUpData, Bingo75NextGameData, Bingo75ResetData } from '@/components/game/implementations/uk/bingo-75/_domain/models';
import { Bingo75LinesCallsData, Bingo75LinesCatchUpData, Bingo75LinesNextGameData, Bingo75LinesResetData } from '@/components/game/implementations/uk/bingo-75-lines/_domain/models';
import { Bingo60CallsData, Bingo60CatchUpData, Bingo60NextGameData, Bingo60ResetData } from '@/components/game/implementations/uk/bingo-60/_domain/models';
import { Bingo50CallsData, Bingo50CatchUpData, Bingo50NextGameData, Bingo50ResetData } from '@/components/game/implementations/uk/bingo-50/_domain/models';
import { Bingo40CallsData, Bingo40CatchUpData, Bingo40NextGameData, Bingo40ResetData } from '@/components/game/implementations/uk/bingo-40/_domain/models';
import { TombolaRouletteCallsData, TombolaRouletteCatchUpData, TombolaRouletteNextGameData, TombolaRouletteResetData } from '@/components/game/implementations/uk/tombola-roulette/_domain/models';
import { BingoLiteCallsData, BingoLiteCatchUpData, BingoLiteNextGameData, BingoLiteResetData } from '@/components/game/implementations/uk/bingo-lite/_domain/models';
import { PulseCallsData, PulseCatchUpData, PulseNextGameData, PulseResetData } from '@/components/game/implementations/uk/pulse/_domain/models';
import { HamsterRaceCallsData, HamsterRaceCatchUpData, HamsterRaceNextGameData, HamsterRaceResetData } from '@/components/game/implementations/uk/hamster-race/_domain/models';
import { PiratesCallsData, PiratesCatchUpData, PiratesNextGameData, PiratesResetData } from '@/components/game/implementations/uk/pirates/_domain/models';
import { PictureBingoCallsData, PictureBingoCatchUpData, PictureBingoNextGameData, PictureBingoResetData } from '@/components/game/implementations/uk/picture-bingo/_domain/models';
import { RollerCoasterCallsData, RollerCoasterCatchUpData, RollerCoasterNextGameData, RollerCoasterResetData } from '@/components/game/implementations/uk/roller-coaster/_domain/models';
import { Lucky7CallsData, Lucky7CatchUpData, Lucky7ResetData, Lucky7NextGameData } from '@/components/game/implementations/uk/lucky-7/_domain/models';
import { CincoCallsData, CincoCatchUpData, CincoNextGameData, CincoResetData } from '@/components/game/implementations/uk/cinco/_domain/models';
import { BlocksCallsData, BlocksCatchUpData, BlocksNextGameData, BlocksResetData } from '@/components/game/implementations/uk/blocks/_domain/models';
import { BingoRouletteCallsData, BingoRouletteCatchUpData, BingoRouletteNextGameData, BingoRouletteResetData } from '@/components/game/implementations/uk/bingo-roulette/_domain/models';
import { PotionCallsData, PotionCatchUpData, PotionNextGameData, PotionResetData } from '@/components/game/implementations/uk/potion/_domain/models';
import { MorphCallsData, MorphCatchUpData, MorphNextGameData, MorphResetData } from '@/components/game/implementations/uk/morph/_domain/models';
import { TheMachineCallsData, TheMachineCatchUpData, TheMachineNextGameData, TheMachineResetData } from '@/components/game/implementations/uk/the-machine/_domain/models';
import { PaperCallsData, PaperCatchUpData, PaperNextGameData, PaperResetData } from '@/components/game/implementations/uk/paper/_domain/models';
import { HexCallsData, HexCatchupData, HexNextGameData, HexResetData } from '@/components/game/implementations/uk/hex/_domain/models/prize';
import { BubbleBingoCallsData, BubbleBingoCatchUpData, BubbleBingoNextGameData, BubbleBingoResetData } from '@/components/game/implementations/uk/bubble-bingo/_domain/models';
import { NevadaCallsData, NevadaCatchUpData, NevadaNextGameData, NevadaResetData } from '@/components/game/implementations/uk/nevada/_domain/models';
import { JigsawCallsData, JigsawCatchUpData, JigsawNextGameData, JigsawResetData } from '@/components/game/implementations/uk/jigsaw/_domain/models';
import { BloomCallsData, BloomCatchUpData, BloomNextGameData, BloomResetData } from '@/components/game/implementations/uk/bloom/_domain/models';
import { ReelBingoCallsData, ReelBingoCatchUpData, ReelBingoNextGameData, ReelBingoResetData } from '@/components/game/implementations/uk/reel-bingo/_domain/models';
import { PaintByNumbersCallsData, PaintByNumbersCatchUpData, PaintByNumbersNextGameData, PaintByNumbersResetData } from '@/components/game/implementations/uk/paint-by-numbers/_domain/models';
import { Bingo30CallsData, Bingo30CatchUpData, Bingo30NextGameData, Bingo30ResetData } from '@/components/game/implementations/uk/bingo-30/_domain/models';
import { StarshipCallsData, StarshipCatchUpData, StarshipNextGameData, StarshipResetData } from '@/components/game/implementations/uk/starship/_domain/models';
import { WordsearchCallsData, WordsearchCatchUpData, WordsearchNextGameData, WordsearchResetData } from '@/components/game/implementations/uk/wordsearch/_domain/models';
import { DondBingoCallsData, DondBingoCatchUpData, DondBingoNextGameData, DondBingoResetData, DondBingoBoxNumberData } from '@/components/game/implementations/uk/dondbingo/_domain/models';

class GamePrizeDescriptorsUk {
  public getGamePrizeClasses(): { [key: string]: IPrizeClassDescriptor; } {
    return {
      bingo90: {
        callsDataClass: Bingo90CallsData,
        catchUpDataClass: Bingo90CatchUpData,
        nextGameDataClass: Bingo90NextGameData,
        resetDataClass: Bingo90ResetData
      },
      bingo80: {
        callsDataClass: Bingo80CallsData,
        catchUpDataClass: Bingo80CatchUpData,
        nextGameDataClass: Bingo80NextGameData,
        resetDataClass: Bingo80ResetData
      },
      bingo75: {
        callsDataClass: Bingo75CallsData,
        catchUpDataClass: Bingo75CatchUpData,
        nextGameDataClass: Bingo75NextGameData,
        resetDataClass: Bingo75ResetData
      },
      bingo75lines: {
        callsDataClass: Bingo75LinesCallsData,
        catchUpDataClass: Bingo75LinesCatchUpData,
        nextGameDataClass: Bingo75LinesNextGameData,
        resetDataClass: Bingo75LinesResetData
      },
      bingo60: {
        callsDataClass: Bingo60CallsData,
        catchUpDataClass: Bingo60CatchUpData,
        nextGameDataClass: Bingo60NextGameData,
        resetDataClass: Bingo60ResetData
      },
      bingo50: {
        callsDataClass: Bingo50CallsData,
        catchUpDataClass: Bingo50CatchUpData,
        nextGameDataClass: Bingo50NextGameData,
        resetDataClass: Bingo50ResetData
      },
      bingo40: {
        callsDataClass: Bingo40CallsData,
        catchUpDataClass: Bingo40CatchUpData,
        nextGameDataClass: Bingo40NextGameData,
        resetDataClass: Bingo40ResetData
      },
      tombolaroulette: {
        callsDataClass: TombolaRouletteCallsData,
        catchUpDataClass: TombolaRouletteCatchUpData,
        nextGameDataClass: TombolaRouletteNextGameData,
        resetDataClass: TombolaRouletteResetData
      },
      bingolite: {
        callsDataClass: BingoLiteCallsData,
        catchUpDataClass: BingoLiteCatchUpData,
        nextGameDataClass: BingoLiteNextGameData,
        resetDataClass: BingoLiteResetData
      },
      bingoroulette: {
        callsDataClass: BingoRouletteCallsData,
        catchUpDataClass: BingoRouletteCatchUpData,
        nextGameDataClass: BingoRouletteNextGameData,
        resetDataClass: BingoRouletteResetData
      },
      cinco: {
        callsDataClass: CincoCallsData,
        catchUpDataClass: CincoCatchUpData,
        nextGameDataClass: CincoNextGameData,
        resetDataClass: CincoResetData
      },
      pulse: {
        callsDataClass: PulseCallsData,
        catchUpDataClass: PulseCatchUpData,
        nextGameDataClass: PulseNextGameData,
        resetDataClass: PulseResetData
      },
      hamsterrace: {
        callsDataClass: HamsterRaceCallsData,
        catchUpDataClass: HamsterRaceCatchUpData,
        nextGameDataClass: HamsterRaceNextGameData,
        resetDataClass: HamsterRaceResetData
      },
      pirates: {
        callsDataClass: PiratesCallsData,
        catchUpDataClass: PiratesCatchUpData,
        nextGameDataClass: PiratesNextGameData,
        resetDataClass: PiratesResetData
      },
      picturebingo: {
        callsDataClass: PictureBingoCallsData,
        catchUpDataClass: PictureBingoCatchUpData,
        nextGameDataClass: PictureBingoNextGameData,
        resetDataClass: PictureBingoResetData
      },
      rollercoaster: {
        callsDataClass: RollerCoasterCallsData,
        catchUpDataClass: RollerCoasterCatchUpData,
        nextGameDataClass: RollerCoasterNextGameData,
        resetDataClass: RollerCoasterResetData
      },
      lucky7: {
        callsDataClass: Lucky7CallsData,
        catchUpDataClass: Lucky7CatchUpData,
        nextGameDataClass: Lucky7NextGameData,
        resetDataClass: Lucky7ResetData
      },
      blocks: {
        callsDataClass: BlocksCallsData,
        catchUpDataClass: BlocksCatchUpData,
        nextGameDataClass: BlocksNextGameData,
        resetDataClass: BlocksResetData
      },
      potion: {
        callsDataClass: PotionCallsData,
        catchUpDataClass: PotionCatchUpData,
        nextGameDataClass: PotionNextGameData,
        resetDataClass: PotionResetData
      },
      morph: {
        callsDataClass: MorphCallsData,
        catchUpDataClass: MorphCatchUpData,
        nextGameDataClass: MorphNextGameData,
        resetDataClass: MorphResetData
      },
      themachine: {
        callsDataClass: TheMachineCallsData,
        catchUpDataClass: TheMachineCatchUpData,
        nextGameDataClass: TheMachineNextGameData,
        resetDataClass: TheMachineResetData
      },
      paper: {
        callsDataClass: PaperCallsData,
        catchUpDataClass: PaperCatchUpData,
        nextGameDataClass: PaperNextGameData,
        resetDataClass: PaperResetData
      },
      hex: {
        callsDataClass: HexCallsData,
        catchUpDataClass: HexCatchupData,
        nextGameDataClass: HexNextGameData,
        resetDataClass: HexResetData
      },
      bubblebingo: {
        callsDataClass: BubbleBingoCallsData,
        catchUpDataClass: BubbleBingoCatchUpData,
        nextGameDataClass: BubbleBingoNextGameData,
        resetDataClass: BubbleBingoResetData
      },
      nevada: {
        callsDataClass: NevadaCallsData,
        catchUpDataClass: NevadaCatchUpData,
        nextGameDataClass: NevadaNextGameData,
        resetDataClass: NevadaResetData
      },
      jigsaw: {
        callsDataClass: JigsawCallsData,
        catchUpDataClass: JigsawCatchUpData,
        nextGameDataClass: JigsawNextGameData,
        resetDataClass: JigsawResetData
      },
      bloom: {
        callsDataClass: BloomCallsData,
        catchUpDataClass: BloomCatchUpData,
        nextGameDataClass: BloomNextGameData,
        resetDataClass: BloomResetData
      },
      reelbingo: {
        callsDataClass: ReelBingoCallsData,
        catchUpDataClass: ReelBingoCatchUpData,
        nextGameDataClass: ReelBingoNextGameData,
        resetDataClass: ReelBingoResetData
      },
      paintbynumbers: {
        callsDataClass: PaintByNumbersCallsData,
        catchUpDataClass: PaintByNumbersCatchUpData,
        nextGameDataClass: PaintByNumbersNextGameData,
        resetDataClass: PaintByNumbersResetData
      },
      bingo30: {
        callsDataClass: Bingo30CallsData,
        catchUpDataClass: Bingo30CatchUpData,
        nextGameDataClass: Bingo30NextGameData,
        resetDataClass: Bingo30ResetData
      },
      starship: {
        callsDataClass: StarshipCallsData,
        catchUpDataClass: StarshipCatchUpData,
        nextGameDataClass: StarshipNextGameData,
        resetDataClass: StarshipResetData
      },
      wordsearch: {
        callsDataClass:  WordsearchCallsData,
        catchUpDataClass:  WordsearchCatchUpData,
        nextGameDataClass:  WordsearchNextGameData,
        resetDataClass:  WordsearchResetData
      },
      dondbingo: {
        callsDataClass:  DondBingoCallsData,
        catchUpDataClass:  DondBingoCatchUpData,
        nextGameDataClass:  DondBingoNextGameData,
        resetDataClass:  DondBingoResetData,
        boxNumbersDataClass: DondBingoBoxNumberData
      }
    };
  }
}

export { GamePrizeDescriptorsUk };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/_domain/server/_factory/game-class-bindings-country-specific/game-class-bindings-uk.ts